import React from 'react';
import { IAuditoriaLancamentoManualResultado } from '../interfaces/IAuditoriaLancamentoManual';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaLancamentoManualResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Auditoria de Lançamentos com Palavra-Chave "Manual" — não é um tributo, é uma auditoria de
// governança que varre todo o livro (Ativo, Passivo, Resultado) procurando lançamentos cujo
// histórico cite "manual" (CPC 00 — Estrutura Conceitual). Sem aplicação de multa.
const AuditoriaResumoLancamentoManual: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = resultado.lancamentosManuais?.length || 0;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Lançamentos com Palavra-Chave "Manual"</h3>
      <p className='text-muted'>
        Auditoria complementar — lançamentos com histórico citando "manual" indicam ausência de origem sistêmica
        integrada, reduzindo a rastreabilidade da escrituração (CPC 00). Clique para ver a análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Valor Identificado</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_LANCAMENTO_MANUAL')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Auditoria de Lançamentos com Palavra-Chave "Manual"</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} lançamento{totalOcorrencias === 1 ? '' : 's'} manual{totalOcorrencias === 1 ? '' : 'is'} identificado{totalOcorrencias === 1 ? '' : 's'} de {resultado.totalLancamentosAnalisados} analisado{resultado.totalLancamentosAnalisados === 1 ? '' : 's'} no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFinanceiroTotal)}
                <div className='auditoria-kpi-help'>Sem multa aplicável (CPC 00)</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoLancamentoManual;
